'use strict';

var _ = require('lodash');
var FaresOptimizerSaveAdjustedFaresService = function FaresOptimizerSaveAdjustedFaresService(app, $filter, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function updateGroupedRowsFares(result, recommendationEntry, selectedHostLadderData, hostLadder, fareLaddersInGroup) {
    recommendationEntry.hostLadder = getHostLadderData(result.groupedRows, hostLadder);
    recommendationEntry.data = result;
    selectedHostLadderData.data = result;
    var selectedFareLadder = _.find(fareLaddersInGroup, {
      fareRecommendationRecordKey: recommendationEntry.recomId
    });
    var index = _.indexOf(fareLaddersInGroup, selectedFareLadder);
    fareLaddersInGroup.splice(index, 1, result);
  }
  function getUserAdjustedDatesRequiredFields() {
    return {
      ticketingDates: [],
      reservationDates: [],
      outboundSeasons: [],
      inboundSeasons: [],
      outboundBlackouts: [],
      inboundBlackouts: [],
      outboundTravelDates: [],
      inboundTravelDates: []
    };
  }
  function fillDatesForTheGivenRbd(rbdLevelUserAdjustedDates, rbd, dateTypeName, adjustedDate, userAdjustedDates, isIgnoreRecord) {
    rbdLevelUserAdjustedDates[rbd] = rbdLevelUserAdjustedDates[rbd] ? rbdLevelUserAdjustedDates[rbd] : getUserAdjustedDatesRequiredFields();
    if (_.isEmpty(adjustedDate)) {
      rbdLevelUserAdjustedDates[rbd][dateTypeName] = _.isEmpty(rbdLevelUserAdjustedDates[rbd][dateTypeName]) ? [] : rbdLevelUserAdjustedDates[rbd][dateTypeName];
    } else {
      isIgnoreRecord = false;
      rbdLevelUserAdjustedDates[rbd][dateTypeName] = rbdLevelUserAdjustedDates[rbd][dateTypeName] ? rbdLevelUserAdjustedDates[rbd][dateTypeName] : [];
      rbdLevelUserAdjustedDates[rbd][dateTypeName].push(adjustedDate);
      rbdLevelUserAdjustedDates[rbd]['inboundDaysOfWeek'] = userAdjustedDates.inboundDaysOfWeek;
      rbdLevelUserAdjustedDates[rbd]['outboundDaysOfWeek'] = userAdjustedDates.outboundDaysOfWeek;
    }
  }
  function fillDatesForAllRbds(rbdLevelUserAdjustedDates, allRbds, dateTypeName, adjustedDate, userAdjustedDates) {
    _.map(allRbds, function (eachRbd) {
      fillDatesForTheGivenRbd(rbdLevelUserAdjustedDates, eachRbd, dateTypeName, adjustedDate, userAdjustedDates);
    });
  }
  function consolidateUserAdjustedDates(hostLadder, userAdjustedDates) {
    var allRbds = _.map(hostLadder, function (eachLadder) {
      return eachLadder.rbd;
    });
    var rbdLevelUserAdjustedDates = {};
    var isIgnoreRecord;
    _.map(userAdjustedDates, function (userAdjustedDate, dateTypeName) {
      if (dateTypeName === 'inboundDaysOfWeek' || dateTypeName === 'outboundDaysOfWeek') {
        return false;
      }
      _.map(userAdjustedDate, function (adjustedDate) {
        isIgnoreRecord = true;
        var rbd = adjustedDate.rbd;
        delete adjustedDate.rbd;
        if (_.isEmpty(rbd)) {
          isIgnoreRecord = false;
          fillDatesForAllRbds(rbdLevelUserAdjustedDates, allRbds, dateTypeName, adjustedDate, userAdjustedDates);
        } else {
          fillDatesForTheGivenRbd(rbdLevelUserAdjustedDates, rbd, dateTypeName, adjustedDate, userAdjustedDates, isIgnoreRecord);
        }
      });
    });
    return rbdLevelUserAdjustedDates;
  }
  function getAlignLadderPayload(fareRecordKey, hostLadder, consolidatedUserAdjustedDates) {
    var regularFbcsFromFareLadder = getRegularFbcsFromFareLadder(hostLadder);
    var alignedLadder = _.map(regularFbcsFromFareLadder, function (rbdEntry) {
      return {
        market: rbdEntry.market,
        rbd: rbdEntry.rbd,
        fbc: rbdEntry.fbc,
        effectiveTotalFare: rbdEntry.effectiveTotalFare
      };
    });
    return {
      recordKey: fareRecordKey,
      alignedWith: hostLadder.alignedWith,
      competitorHostCarrier: hostLadder.competitorHostCarrier,
      competitorCarrier: hostLadder.competitorCarrier,
      competitorFbc: hostLadder.competitorFbc,
      competitorOrigin: hostLadder.competitorOrigin,
      competitorDestination: hostLadder.competitorDestination,
      competitorTariffCode: hostLadder.competitorTariffCode,
      competitorRoutingNumber: hostLadder.competitorRoutingNumber,
      competitorFootnote: hostLadder.competitorFootnote,
      ladderMethod: hostLadder.ladderMethod,
      rbdFareRecommendations: alignedLadder,
      rbdLevelUserAdjustedDates: consolidatedUserAdjustedDates || null,
      competitorFareSource: hostLadder.competitorFareSource
    };
  }
  function getRegularFbcsFromFareLadder(hostLadder) {
    return _.filter(hostLadder, function (effFare) {
      return _.isNil(effFare.sponsorMarketFbc) && _.isNil(effFare.dualRbdSponsorFbc);
    });
  }
  function getRegularFbcGroupedRows(groupedRows) {
    return _.filter(groupedRows, function (groupedRow) {
      return !groupedRow.isLinkedFbc && !groupedRow.isDualRbdFare;
    });
  }
  function fareInversionCheck(hostLadder, recommendationEntry) {
    var fareInversionExists = false;
    var regularFbcFareLadder = getRegularFbcsFromFareLadder(hostLadder);
    var recomEntryRegularFbcFareLadder = getRegularFbcsFromFareLadder(recommendationEntry.hostLadder);
    _.forEach(recomEntryRegularFbcFareLadder, function (effFare, index) {
      if (index > 0) {
        var lowerFareClass = regularFbcFareLadder[index - 1];
        var upperFareClass = regularFbcFareLadder[index];
        if (notCancelledFare(lowerFareClass, upperFareClass)) {
          if (lowerFareClass.effectiveTotalFare > upperFareClass.effectiveTotalFare) {
            fareInversionExists = true;
            if (recomEntryRegularFbcFareLadder[index - 1].effectiveTotalFare !== lowerFareClass.effectiveTotalFare) {
              lowerFareClass.effFareClass = 'highlighted-fare fare-value effective-fare-section';
            }
            if (recomEntryRegularFbcFareLadder[index].effectiveTotalFare !== upperFareClass.effectiveTotalFare) {
              upperFareClass.effFareClass = 'highlighted-fare fare-value effective-fare-section';
            }
          }
        }
      }
    });
    return fareInversionExists;
  }
  function notCancelledFare(lowerFareClass, upperFareClass) {
    return !(lowerFareClass.actionCode === 'X' || upperFareClass.actionCode === 'X');
  }
  function getValidInvalidRbdsAndDates(recommendationEntry, userAdjustedDates) {
    var validRbds = [];
    var sponsorRows = _.filter(recommendationEntry.data.groupedRows, {
      isLinkedFbc: false
    });
    if (sponsorRows.length === 1) {
      if (!_.isEmpty(sponsorRows[0].selectedCompetitorKey)) {
        validRbds.push(sponsorRows[0].rbd);
      }
    } else {
      _.each(recommendationEntry.data.groupedRows, function (ladder) {
        if (ladder.fbc !== recommendationEntry.data.hostHighestFbc && !_.isEmpty(ladder.selectedCompetitorKey)) {
          validRbds.push(ladder.rbd);
        }
      });
    }
    var invalidRbds = [];
    var emptyDateFields = [];
    _.map(userAdjustedDates, function (adjustedDates) {
      _.map(adjustedDates, function (dates) {
        if (dates.rbd && dates.rbd !== '' && validRbds.indexOf(dates.rbd) === -1) {
          invalidRbds.push(dates.rbd);
        }
        if (dates.$$hashKey && _.isEmpty(_.intersection(_.keys(dates), ['begin', 'end', 'from', 'to', 'complete']))) {
          emptyDateFields.push(dates.rbd);
        }
      });
    });
    return {
      validRbds: validRbds,
      invalidRbds: invalidRbds,
      emptyDateFields: emptyDateFields
    };
  }
  function getFormattedDate(dateString) {
    return dateString ? rmMomentFormat(momentService.of(dateString, momentService.DATE_USER_SETTINGS), momentService.DATE_USER_SETTINGS) : dateString;
  }
  function isDateOverlapping(date1From, date1To, date2From, date2To) {
    var d1From = date1From ? new Date(date1From) : date1From;
    var d1To = date1To ? new Date(date1To) : date1To;
    var d2From = date2From ? new Date(date2From) : date2From;
    var d2To = date2To ? new Date(date2To) : date2To;
    return d1From === d2From || d1To === d2To || d2From >= d1From && d2From <= d1To || d2To >= d1From && d2To <= d1To || d2From >= d1From && d2From <= d1To || !_.isNil(d1From) && d1From === d2To || !_.isNil(d1To) && d1To === d2From || _.isNil(d1From) && d2From <= d1To || _.isNil(d1To) && d2To >= d1From || _.isNil(d2From) && d1From <= d2To || _.isNil(d2To) && d1To >= d2From || d2From < d1From && d2To > d1To;
  }
  function areDatesOverlapping(adjustedDates, dateFields) {
    var fields = dateFields.split(':');
    var recordCount = adjustedDates.length;
    for (var i = 0; i < recordCount - 1; i++) {
      for (var j = i + 1; j < recordCount; j++) {
        if (isDateOverlapping(adjustedDates[i][fields[0]], adjustedDates[i][fields[1]], adjustedDates[j][fields[0]], adjustedDates[j][fields[1]])) {
          return [[fields[0], getFormattedDate(adjustedDates[i][fields[0]])].join(': '), ', ', [fields[1], getFormattedDate(adjustedDates[i][fields[1]])].join(': '), ' and ', [fields[0], getFormattedDate(adjustedDates[j][fields[0]])].join(': '), ', ', [fields[1], getFormattedDate(adjustedDates[j][fields[1]])].join(': ')].join('');
        }
      }
    }
    return false;
  }
  function areOverlappingDates(consolidatedUserAdjustedDates) {
    var dateTypesFields = getAdjustedDatesOptions();
    var dateTypesToCheck = _.keys(getUserAdjustedDatesRequiredFields());
    for (var i in consolidatedUserAdjustedDates) {
      for (var j = 0; j < dateTypesToCheck.length; j++) {
        var overlapBlock = areDatesOverlapping(consolidatedUserAdjustedDates[i][dateTypesToCheck[j]], dateTypesFields[dateTypesToCheck[j]].fields);
        if (overlapBlock) {
          return dateTypesToCheck[j] + ' [ ' + i + ' ] - ' + overlapBlock;
        }
      }
    }
    return false;
  }
  function isPassedInOtherDateType(inValidData, rbds) {
    var foundRecord = _.filter(inValidData, function (data) {
      return _.find(data, rbds);
    });
    return !_.isEmpty(foundRecord);
  }
  function getFailedRbdsAndSetItToTrue(inValidData) {
    var failedRbds = {};
    _.each(inValidData, function (data) {
      _.each(data.rbdLevelPrimaryCheck, function (rbdValue, rbdName) {
        if (!rbdValue) {
          failedRbds[rbdName] = true;
        }
      });
    });
    return failedRbds;
  }
  function primaryCriteriaCheck(userAdjustedDates, properties) {
    var primaryCriteriaData = {
      isPrimaryCheckPassed: true,
      failedRbds: ''
    };
    if (_.isNil(properties)) {
      return primaryCriteriaData;
    }
    var groupedProperties = _.groupBy(properties, 'criteriaType');
    if (!_.isNil(groupedProperties) && _.isNil(groupedProperties['Date'])) {
      return primaryCriteriaData;
    }
    var systemDate = getSystemDate();
    var isValidatePrimaryCheck = false;
    var inValidData = {
      reservationEndDates: {},
      ticketingEndDates: {},
      inboundTravelEndDates: {},
      outboundTravelEndDates: {}
    };
    _.forEach(groupedProperties['Date'], function (property) {
      if (property.criteria === 'Reservation End Date (FN)') {
        inValidData.reservationEndDates = getOutOfRangeDates(property, userAdjustedDates.reservationDates, systemDate);
        isValidatePrimaryCheck = isValidatePrimaryCheck || !_.isEmpty(inValidData.reservationEndDates);
      } else if (property.criteria === 'Ticketing End Date (FN)') {
        inValidData.ticketingEndDates = getOutOfRangeDates(property, userAdjustedDates.ticketingDates, systemDate);
        isValidatePrimaryCheck = isValidatePrimaryCheck || !_.isEmpty(inValidData.ticketingEndDates);
      } else if (property.criteria === 'Travel End Date (FN)') {
        inValidData.inboundTravelEndDates = getOutOfRangeDates(property, userAdjustedDates.inboundTravelDates, systemDate);
        inValidData.outboundTravelEndDates = getOutOfRangeDates(property, userAdjustedDates.outboundTravelDates, systemDate);
        isValidatePrimaryCheck = isValidatePrimaryCheck || !_.isEmpty(inValidData.inboundTravelEndDates) || !_.isEmpty(inValidData.outboundTravelEndDates);
      }
    });
    if (isValidatePrimaryCheck) {
      var failedRbds = getFailedRbdsAndSetItToTrue(inValidData);
      primaryCriteriaData.isPrimaryCheckPassed = _.isEmpty(failedRbds) ? true : isPassedInOtherDateType(inValidData, failedRbds);
      primaryCriteriaData.failedRbds = _.keys(failedRbds).join(' | ');
    }
    return primaryCriteriaData;
  }
  function getOutOfRangeDates(property, dateRanges, systemDate) {
    if (_.isEmpty(dateRanges) || _.isEmpty(dateRanges[0]) || _.isEmpty(dateRanges[0].begin) && _.isEmpty(dateRanges[0].end) && _.isEmpty(dateRanges[0].from) && _.isEmpty(dateRanges[0].to)) {
      return {};
    }
    var adjustedEndDate = getAdjustedDateBasedOnCriteria(systemDate, property.operator, property.value);
    if (_.isNil(adjustedEndDate)) {
      return {};
    }
    var startEndKeys = isCriteriaDateRangeType(property.criteria) ? {
      start: 'begin',
      end: 'end'
    } : isCriteriaTravelDateRangeType(property.criteria) ? {
      start: 'from',
      end: 'to'
    } : {};
    if (_.isNil(startEndKeys)) {
      return {};
    }
    return getDatesToBeAdjustedBasedOnOperator(property, dateRanges, adjustedEndDate, startEndKeys);
  }
  function isCriteriaDateRangeType(criteria) {
    return criteria === 'Reservation End Date (FN)' || criteria === 'Ticketing End Date (FN)';
  }
  function isCriteriaTravelDateRangeType(criteria) {
    return criteria === 'Travel End Date (FN)';
  }
  function isCheckDateBasedOnOperator(operator, compareDate, adjustedEndDate) {
    return operator === '<=' && compareDate > adjustedEndDate || operator === '>=' && compareDate < adjustedEndDate || (operator === '<' || operator === '>') && compareDate >= adjustedEndDate || operator === '=' && compareDate !== adjustedEndDate || operator === '!=' && compareDate === adjustedEndDate;
  }
  function getDatesToBeAdjustedBasedOnOperator(property, dateRanges, adjustedEndDate, startEnd) {
    var datesToBeAdjusted = [];
    var rbdLevelPrimaryCheck = {};
    _.forEach(dateRanges, function (dateRange) {
      if (_.isNil(dateRange[startEnd.end]) && !_.isNil(dateRange[startEnd.start]) || !_.isNil(dateRange[startEnd.end]) && isCheckDateBasedOnOperator(property.operator, new Date(dateRange[startEnd.end]), adjustedEndDate)) {
        datesToBeAdjusted.push(dateRange);
        rbdLevelPrimaryCheck[dateRange.rbd] = false;
      } else {
        rbdLevelPrimaryCheck[dateRange.rbd] = rbdLevelPrimaryCheck[dateRange.rbd] !== false ? true : rbdLevelPrimaryCheck[dateRange.rbd];
      }
    });
    return {
      datesToBeAdjusted: datesToBeAdjusted,
      rbdLevelPrimaryCheck: rbdLevelPrimaryCheck
    };
  }
  function getAdjustedDate(systemDate, value) {
    var adjustedDate = new Date(systemDate);
    adjustedDate.setDate(adjustedDate.getDate() + value);
    return adjustedDate;
  }
  function getAdjustedDateBasedOnCriteria(systemDate, operator, value) {
    switch (operator) {
      case '<=':
      case '>=':
      case '=':
      case '!=':
        return getAdjustedDate(systemDate, Number(value));
      case '<':
        return getAdjustedDate(systemDate, Number(value - 1));
      case '>':
        return getAdjustedDate(systemDate, Number(value + 1));
      default:
        return null;
    }
  }
  function getSystemDate() {
    var systemDate;
    if (!_.isNil(app.foSimpleHep.FO_MOCK_SYSTEM_DATE)) {
      systemDate = app.foSimpleHep.FO_MOCK_SYSTEM_DATE;
    } else {
      systemDate = new Date().toISOString().split('T')[0];
    }
    return systemDate;
  }
  function modifiedFareWithinFareThresholdCheck(hostLadder) {
    var isFareWithinThreshold = true;
    _.forEach(hostLadder, function (hostRbd) {
      if (!_.isNil(hostRbd.minFareThreshold) && !_.isNil(hostRbd.maxFareThreshold) && (hostRbd.effectiveTotalFare < hostRbd.minFareThreshold || hostRbd.effectiveTotalFare > hostRbd.maxFareThreshold)) {
        isFareWithinThreshold = false;
        hostRbd.effFareClass = 'highlighted-fare fare-value effective-fare-section';
      }
    });
    return isFareWithinThreshold;
  }
  function getHostLadderData(groupedRows, hostLadder, smoothingMethod) {
    var regularFbcGroupedRows = getRegularFbcGroupedRows(groupedRows);
    var regularFbcsFromFareLadder = getRegularFbcsFromFareLadder(hostLadder);
    var updatedHostLadder = _.chain(regularFbcGroupedRows).map(function (row) {
      row.rbdIndex = _.indexOf(app.foRbds, row.rbd);
      return row;
    }).sortBy('rbdIndex').reduce(function (updatedLadder, groupedRow) {
      updatedLadder.push({
        market: groupedRow.market,
        rbd: groupedRow.rbd,
        rbdLabel: getRbdLabel(groupedRow),
        fbc: groupedRow.fbc,
        useForLadderGenerationInd: groupedRow.useForLadderGenerationInd,
        isMappedRbd: groupedRow.isMappedRbd,
        rbdLabelCustomClass: getCustomRbdLabelClass(groupedRow, regularFbcsFromFareLadder),
        effectiveTotalFare: groupedRow.effectiveTotalFare,
        minFareThreshold: groupedRow.minFareThreshold,
        maxFareThreshold: groupedRow.maxFareThreshold,
        sponsorMarketFbc: groupedRow.sponsorMarketFbc,
        dualRbdSponsorFbc: groupedRow.dualRbdSponsorFbc,
        percentageLinkageFactor: groupedRow.percentageLinkageFactor,
        absoluteLinkageFactor: groupedRow.absoluteLinkageFactor,
        effFareClass: 'fare-value effective-fare-section',
        benchmarkFareComponent: groupedRow.benchmarkFareComponent,
        yq: groupedRow.yq,
        yr: groupedRow.yr,
        sixH: groupedRow.sixH,
        sixI: groupedRow.sixI,
        sixJ: groupedRow.sixJ,
        sixK: groupedRow.sixK,
        q: groupedRow.q,
        airportTax: groupedRow.airportTax,
        variable: groupedRow.variable,
        variableTaxPercentage: groupedRow.variableTaxPercentage,
        actionCode: groupedRow.actionCode
      });
      return updatedLadder;
    }, []).value();
    updatedHostLadder.alignedWith = hostLadder.alignedWith;
    updatedHostLadder.competitorCarrier = hostLadder.competitorCarrier;
    updatedHostLadder.competitorHostCarrier = hostLadder.competitorHostCarrier;
    updatedHostLadder.competitorFbc = hostLadder.competitorFbc;
    updatedHostLadder.competitorOrigin = hostLadder.competitorOrigin;
    updatedHostLadder.competitorDestination = hostLadder.competitorDestination;
    updatedHostLadder.competitorTariffCode = hostLadder.competitorTariffCode;
    updatedHostLadder.competitorRoutingNumber = hostLadder.competitorRoutingNumber;
    updatedHostLadder.competitorFootnote = hostLadder.competitorFootnote;
    updatedHostLadder.competitorFareSource = hostLadder.competitorFareSource;
    updatedHostLadder.ladderMethod = smoothingMethod;
    return updatedHostLadder;
  }
  function getRbdLabel(groupedRow) {
    var rbdLabel = groupedRow.rbd;
    return groupedRow.useForLadderGenerationInd === false ? rbdLabel + '*' : rbdLabel;
  }
  function getCustomRbdLabelClass(row, hostLadder) {
    var modifiedFareRecommendation = _.find(hostLadder, {
      rbd: row.rbd
    });
    return modifiedFareRecommendation.rbdLabelCustomClass;
  }
  function getAdjustedDatesOptions() {
    return {
      salesDates: {
        fields: 'begin:end',
        options: [{
          value: 'ticketingDates',
          label: 'Ticketing',
          "default": true
        }, {
          value: 'reservationDates',
          label: 'Reservation'
        }]
      },
      ticketingDates: {
        fields: 'begin:end'
      },
      reservationDates: {
        fields: 'begin:end'
      },
      inboundSeasons: {
        fields: 'begin:end',
        fieldName: 'inboundSeasons',
        required: true,
        applicableDateRange: true
      },
      outboundSeasons: {
        fields: 'begin:end',
        fieldName: 'outboundSeasons',
        required: true,
        applicableDateRange: true
      },
      inboundTravelDates: {
        fields: 'from:to:complete',
        fieldName: 'inboundTravelDates'
      },
      outboundTravelDates: {
        fields: 'from:to:complete',
        fieldName: 'outboundTravelDates'
      },
      inboundBlackouts: {
        fields: 'begin:end',
        fieldName: 'inboundBlackouts',
        required: true,
        applicableDateRange: true
      },
      outboundBlackouts: {
        fields: 'begin:end',
        fieldName: 'outboundBlackouts',
        required: true,
        applicableDateRange: true
      }
    };
  }
  return {
    updateGroupedRowsFares: updateGroupedRowsFares,
    getUserAdjustedDatesRequiredFields: getUserAdjustedDatesRequiredFields,
    getAlignLadderPayload: getAlignLadderPayload,
    fareInversionCheck: fareInversionCheck,
    primaryCriteriaCheck: primaryCriteriaCheck,
    modifiedFareWithinFareThresholdCheck: modifiedFareWithinFareThresholdCheck,
    getHostLadderData: getHostLadderData,
    getValidInvalidRbdsAndDates: getValidInvalidRbdsAndDates,
    getAdjustedDatesOptions: getAdjustedDatesOptions,
    areOverlappingDates: areOverlappingDates,
    consolidateUserAdjustedDates: consolidateUserAdjustedDates
  };
};
FaresOptimizerSaveAdjustedFaresService.$inject = ['App', '$filter', 'MomentService'];
module.exports = FaresOptimizerSaveAdjustedFaresService;